import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeDepatureCity } from '../../../DataStore/actions/searchFormActions';
import { CITY_OPTIONS } from '../../../Utils/Constants/CitiesFrom';
import './css/DepartureCItyPopover.css';

const mapStateToProps = (state) => ({ ...state });

class DepartureCItyPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick = (city) => {
    const { depatureCity, changeDepatureCity: changeDepatureCityAction } =
      this.props;

    if (depatureCity.id !== city.is) {
      changeDepatureCityAction(city);
    }
  };

  renderCities = (cities) =>
    cities.map((city) => (
      <button
        key={city.id}
        type="button"
        className="sf_pop_departure_item br_text_18"
        onClick={() => this.handleClick(city)}
      >
        {city.name}
      </button>
    ));

  render() {
    return (
      <div className="sf_pop_departure_w">
        {this.renderCities(CITY_OPTIONS)}
      </div>
    );
  }
}

DepartureCItyPopover.propTypes = {
  depatureCity: PropTypes.instanceOf(Object).isRequired,
  changeDepatureCity: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { changeDepatureCity })(
  DepartureCItyPopover,
);
